export const AnalyticContexts = {
	Source: 'objectSidebar',
} as const;
